export default defineNuxtPlugin({
  name: 'auth',
  async setup() {
    const userStore = useUserStoreSsr()
    if (import.meta.server) {
      const event = useRequestEvent()!
      userStore.initialiseState(event.context.user)
    }
  },
})
